import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  label{
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
  }

  p {
    color: #ff0000;
  }

  input{
    border: 1px solid #96989A !important;
  }
`;
